export default "__VITE_ASSET__BXc6B8U___"